import {Button} from 'antd';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import {useNavigate} from 'react-router-dom';

import {RQUserRegistrationAPI} from '../../../reactQuery/apis';
import {RegistrationForm} from '../../LoginScreen/RegistrationScreen/RegistrationForm';

const RegistrationScreen = ({setShowRegister, openLoginModal}) => {
  const {mutateAsync: registerUser, isPending} = RQUserRegistrationAPI();

  const onSubmit = async values => {
    try {
      const res = await registerUser(values);

      if (res?.success !== false) {
        toast.success('Registration completed successfully!');
        setShowRegister(false);
        openLoginModal?.();
      } else {
        toast.error(res?.message || 'Registration failed');
      }
    } catch (error) {
      toast.error(error?.message || 'Registration failed');
    }
  };

  return (
    <div className={'flex justify-center items-center h-full'}>
      <div className={'w-full lg:p-4'}>
        <RegistrationForm onSubmit={onSubmit} loading={isPending} />

        <div className={'flex flex-col justify-center'}>
          <Button
            type={'link'}
            className={'w-full mt-4'}
            onClick={openLoginModal}
          >
            Already have an account? Login
          </Button>
        </div>
      </div>
    </div>
  );
};

RegistrationScreen.propTypes = {
  setShowRegister: PropTypes.func.isRequired,
  openLoginModal: PropTypes.func,
};

export default RegistrationScreen;
